/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
  Author: SweetAs
  Author URL: http://sweetas.xyz
==========================================================================================*/

export default {  
  REMOVE_ALL_ITEMS_FROM_CART (state) {
    state.cartItems = []
  },
  REMOVE_ITEM_FROM_CART (state, item) {
    //const index = state.cartItems.findIndex(i => i.objectID === item.objectID)
    const index = state.cartItems.findIndex(i => i.sku === item.sku)
    if (index > -1) { state.cartItems.splice(index, 1) }
  },
  ADD_ITEM_IN_CART (state, item) {
    state.cartItems.push(Object.assign({}, item))
  },
  UPDATE_ITEM_QUANTITY (state, payload) {
    payload.quantity = payload.quantity === '' ? 0 : payload.quantity
    state.cartItems[payload.index].quantity = payload.quantity
  },
  UPDATE_IPID (state, payload) {    
    state.ipid =  payload.IpId || ''
  } 
}

